// material-ui
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

// styles
const LoaderWrapper = styled('div', {
	shouldForwardProp: prop => prop !== 'fullHeight',
})(({ fullHeight }: any) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: fullHeight ? '100vh' : '100%',
}));

const Loader = ({ fullHeight, ...others }: any) => (
	<LoaderWrapper fullHeight={fullHeight} {...others}>
		<CircularProgress
			variant='indeterminate'
			disableShrink
			size={40}
			thickness={4}
		/>
	</LoaderWrapper>
);

export default Loader;
